/** ******************************************************* {COPYRIGHT-TOP} ***
 * Licensed Materials - Property of IBM
 *
 * (C) Copyright IBM Corporation 2016, 2025
 *
 * All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 ********************************************************** {COPYRIGHT-END} * */

import React, { useState } from 'react';
import { Checkbox } from '@carbon/react';
import { useTranslation } from 'react-i18next';

function TestToolScopes({ scopes, onChange }) {
  const { t } = useTranslation();
  const [selectedScopes, setSelectedScopes] = useState({});
  const handleScopeChange = (scope, event) => {
    const newScopes = { ...selectedScopes };
    newScopes[scope] = event.target.checked;
    if (onChange && typeof onChange === 'function') {
      onChange(newScopes);
    }
    setSelectedScopes(newScopes);
  };
  const scopeStates = {};
  for (let i = 0; i < (scopes?.length ?? 0); i += 1) {
    scopeStates[scopes[i]] = false;
  }

  return (
    <div className="scopesChooser">
      <div className="labelText">{t('explorer_scopes')}</div>
      {Object.keys(scopeStates).map((scope) => (
        <Checkbox key={scope} labelText={scope} id={scope} onChange={(e) => handleScopeChange(scope, e)} />
      ))}
    </div>
  );
}

export default TestToolScopes;
